/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookingIdRemarkRuleDelete
 */
export interface BookingIdRemarkRuleDelete {
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleDelete
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BookingIdRemarkRuleDelete
     */
    deleted?: boolean;
}

export function BookingIdRemarkRuleDeleteFromJSON(json: any): BookingIdRemarkRuleDelete {
    return BookingIdRemarkRuleDeleteFromJSONTyped(json, false);
}

export function BookingIdRemarkRuleDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingIdRemarkRuleDelete {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
    };
}

export function BookingIdRemarkRuleDeleteToJSON(value?: BookingIdRemarkRuleDelete | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deleted': value.deleted,
    };
}


